import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { UserPreferenceFacade } from './facades/user-preference/user-preference.facade';
import { UserPreferenceEffects } from './store/effects/user-preference.effects';
import { userPreferenceReducer } from './store/reducers/user-preference.reducer';

@NgModule({
  declarations: [],
  imports: [
    StoreModule.forFeature('userPreferences', userPreferenceReducer),
    EffectsModule.forFeature([UserPreferenceEffects]),
  ],
  providers: [UserPreferenceFacade],
})
export class UserPreferenceModule {}
